import type { FC } from 'react';
import './styles.css';
import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';

export const PencilAltIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper
    width={props.width ?? 16}
    height={props.height ?? 16}
    viewBox='0 0 16 16'
    {...props}
  >
    <path
      d='M6.22989 11L13 4.22989L10.7701 2L4 8.77011M6.22989 11H4V8.77011M6.22989 11L5.11495 9.88505L4 8.77011'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M2 1C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H15.5C15.7761 15 16 15.2239 16 15.5C16 15.7761 15.7761 16 15.5 16H2C0.89543 16 0 15.1046 0 14V2C0 0.895431 0.895431 0 2 0H7C7.27614 0 7.5 0.223858 7.5 0.5C7.5 0.776142 7.27614 1 7 1H2Z'
      fill='currentColor'
    />
    <circle cx='11' cy='11' r='1' fill='currentColor' />
    <circle cx='14' cy='11' r='1' fill='currentColor' />
  </SvgWrapper>
);
